"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageCardVariant = exports.LinkType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const Styled = __importStar(require("./styled"));
const utils_1 = __importDefault(require("./utils"));
var LinkType;
(function (LinkType) {
    LinkType["SALES"] = "sales";
})(LinkType || (exports.LinkType = LinkType = {}));
var MessageCardVariant;
(function (MessageCardVariant) {
    MessageCardVariant["PRIMARY"] = "primary";
    MessageCardVariant["LIGHT"] = "light";
})(MessageCardVariant || (exports.MessageCardVariant = MessageCardVariant = {}));
const MessageAnchor = (aProps) => (0, jsx_runtime_1.jsx)(Styled.Anchor, Object.assign({}, aProps));
const MessageCard = (0, react_1.forwardRef)(function MessageCard(props, ref) {
    const { title, subtitle, image, expiry, read, linkWrapper, link, variant } = props, otherProps = __rest(props, ["title", "subtitle", "image", "expiry", "read", "linkWrapper", "link", "variant"]);
    const LinkWrapper = linkWrapper ? linkWrapper : MessageAnchor;
    return ((0, jsx_runtime_1.jsx)(LinkWrapper, { href: link.url, extractParams: true, children: (0, jsx_runtime_1.jsxs)(Styled.MessageCard, Object.assign({ ref: ref }, otherProps, { children: [(0, jsx_runtime_1.jsxs)(Styled.Content, { children: [image && ((0, jsx_runtime_1.jsx)(Styled.MediaContainer, { "$variant": variant, children: (0, jsx_runtime_1.jsx)(Styled.Media, { "$variant": variant, src: image, alt: title, "data-testid": "notification-media" }) })), (0, jsx_runtime_1.jsxs)(Styled.Details, { "$variant": variant, children: [(0, jsx_runtime_1.jsxs)(Styled.TextContainer, { children: [(0, jsx_runtime_1.jsx)(Styled.Title, { "$variant": variant, dangerouslySetInnerHTML: { __html: (0, utils_1.default)(title) } }), subtitle && (0, jsx_runtime_1.jsx)(Styled.Subtitle, { children: subtitle })] }), expiry && (0, jsx_runtime_1.jsx)(Styled.Expiration, { "data-testid": "notification-exp", children: expiry })] })] }), (0, jsx_runtime_1.jsx)(Styled.ActionContainer, { children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: !read, timeout: 500, classNames: "read-icon-transition", children: (0, jsx_runtime_1.jsx)(Styled.ReadIconTransitionContainer, { children: (0, jsx_runtime_1.jsx)(Styled.ReadIcon, { "data-testid": "notification-read-icon" }) }) }) })] })) }));
});
MessageCard.defaultProps = {
    variant: MessageCardVariant.PRIMARY,
};
exports.default = MessageCard;
